import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../hooks/hooks";
import { user } from "../../../redux/user/actions";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import useWindowDimensions from '../../../hooks/useWindowsDimensions';
import _ from "lodash";
import { termsLibraries } from "../../../redux/terms-libraries/action";
import { selectTermsLibrariesQueryItems } from "../../../redux/terms-libraries/selector";
import { selectSectionsQueryItems } from "../../../redux/sections/selector";

import { sections } from "../../../redux/sections/action";
import PageLoader from "../../../components/PageLoader";
import { HTMLContent } from "../../../components/html-content";
import { useParams } from "react-router-dom";

export const Terms = () => {
    const dispatch = useAppDispatch();
    const { height, width } = useWindowDimensions();
    const termsLibrariesQuery: any = useSelector(selectTermsLibrariesQueryItems)
    const sectionQueryItems: any = useSelector(selectSectionsQueryItems);
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [termsData, setTermsData] = useState<any>({})
    const parmas: any = useParams()


    useEffect(() => {
        getTerms();
    }, [])


    useEffect(() => {
        if (termsLibrariesQuery?.isSuccess && termsLibrariesQuery?.result?.items?.SectionIds.length > 0) {
            dispatch(sections.query({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/terms-library/sections/query`, entity: 'sections', jsonData:
                {
                    "Records": [
                        {
                            "Id": termsLibrariesQuery?.result?.items?.SectionIds[0]
                        }
                    ]
                }
            }))
            dispatch(termsLibraries.resetAction({ actionType: 'query' }))
        }
    }, [termsLibrariesQuery]);

    useEffect(() => {
        if (sectionQueryItems?.isSuccess && sectionQueryItems?.result?.items) {
            setTermsData(sectionQueryItems?.result?.items)
            setIsLoading(false)
            dispatch(sections.resetAction({ actionType: 'query' }))
        }
    }, [sectionQueryItems]);

    const getTerms = async () => {

        dispatch(termsLibraries.query({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/contract/terms-libraries/query`, entity: 'termsLibraries', jsonData:
            {
                Records: [
                    {
                        Id: parmas?.id
                    }
                ]
            }
        }));
    }

    return (
        <>
            {isLoading ? <PageLoader />
                :
                <>
                    {width && width < 720 ? <div className={`max-h-screen py-5`}>
                        <div className="z-20 h-full py-10 pb-24 overflow-y-auto mt-12">
                            <div className="flex w-full flex-col items-start justify-between uppercase text-xl p-10" >
                                {termsData?.Name ? termsData.Name : 'Terms & Conditions'}
                            </div>
                            <div className="p-4 w-full  justity-center items-center">
                                {termsData && <HTMLContent htmlContent={`${termsData?.Description}`} />}
                            </div>
                        </div>

                    </div > :
                        <div className="overflow-y-auto flex flex-col bg-white px-16 py-10 rounded-lg shadow-lg">
                            {/* Title Section */}
                            <div className="text-2xl font-semibold text-gray-800 border-b pb-4 mb-6">
                                Terms & Conditions
                            </div>

                            {/* Content Section */}
                            <div className="w-full">
                                <div className="w-full bg-white">
                                    <div className="text-lg font-medium text-gray-900 uppercase p-6">
                                        {termsData?.Name ? termsData.Name : 'Terms & Conditions'}
                                    </div>
                                    <div className="text-gray-700 leading-relaxed px-6 pb-6">
                                        {termsData && <HTMLContent htmlContent={termsData.Description} />}
                                    </div>
                                </div>
                            </div>
                        </div>}</>
            }
        </>
    )
}

